export const layoutUtils = {
  sideBarButtons: {
    admin: [
      { path: "/admin", label: "Tableau de Bord", icon: "tachometer-alt" },

      {
        path: "/admin/factures",  // or "/admin/invoices" depending on your routing
        label: "Gestion de Factures",
        icon: "invoice" // FontAwesome icon for invoices
      },

      {
        path: "/admin/gifts",
        label: "Gestion des Cadeaux",
        icon: "gift" // FontAwesome icon for gifts
      },
      {
        path: "/admin/gift-requests",
        label: "Demandes de Cadeaux",
        icon: "gift-request" // You can use "gift" or "gift-bag" from FontAwesome
      },
      {
        path: "/admin/sanctions",
        label: "Gestion des Sanctions",
        icon: "exclamation-triangle",
      },
      {
        path: "/admin/ReclamationsDesClients",
        label: "Réclamations des Clients",
        icon: "clipboard-list",
      },
      {
        path: "/admin/ApprobationDesContenus",
        label: "Approbation des Contenus",
        icon: "check-circle",
      },
      {
        path: "/admin/GestionDesRolesEtPermissions",
        label: "Gestion des Rôles et Permissions",
        icon: "lock",
      },
      {
        path: "/admin/AnalyseEtReporting",
        label: "Analyse et Reporting",
        icon: "chart-line",
      },
      {
        path: "/admin/CentreDeSupport",
        label: "Centre de Support",
        icon: "life-ring",
      },
      {
        path: "/admin/credentials",
        label: "Informations Entreprise",
        icon: "building",
      },
      {
        path: "/admin/facturation/configuration",
        label: "Configuration de la facturation",
        icon: "pricing",
      },
      {
        path: "/admin/ai",
        label: "Configuration IA",
        icon: "cogs",
      },
      {
        path: "/admin/company",
        label: "Gestion des Entreprises",
        icon: "company",
      },
    ],
  },
};
